import _ from 'underscore';

import { FilterOps, ICompositeFilterClause, IFieldFilterClause, ILeafFilterClause, IStringArrayValuedFieldFilterClause, IStringValuedFilterClause, IValuedFieldFilterClause } from '../../spacesPlatform/models/IFilterClause';

export module Filter {

  export function and(clauses: ILeafFilterClause[]): ICompositeFilterClause {
    return {
      operator: FilterOps.and,
      clauses: clauses
    };
  }

  export function search(search: string): IStringValuedFilterClause {
    return {
      operator: FilterOps.matches,
      value: search
    };
  }

  export function fieldEq<T>(field: string, value: T): IValuedFieldFilterClause<T> {
    return {
      operator: FilterOps.eq,
      field: field,
      value: value
    };
  }

  export function onField<T>(field: string, operator: IValuedFieldFilterClause<T>['operator'], value: T): IValuedFieldFilterClause<T> {
    return {
      operator,
      field,
      value
    };
  }

  export function stringFieldEq(field: string, value: string): IValuedFieldFilterClause<string> {
    return fieldEq(field, value);
  }

  export function numberFieldEq(field: string, value: number): IValuedFieldFilterClause<number> {
    return fieldEq(field, value);
  }

  export function stringFieldGte(field: string, value: string): IValuedFieldFilterClause<string> {
    return {
      operator: FilterOps.gte,
      field: field,
      value: value
    };
  }

  export function stringFieldLte(field: string, value: string): IValuedFieldFilterClause<string> {
    return {
      operator: FilterOps.lte,
      field: field,
      value: value
    };
  }

  export function stringFieldMatches(field: string, value: string): IValuedFieldFilterClause<string> {
    return {
      operator: FilterOps.matches,
      field: field,
      value: value
    };
  }

  export function stringArrayFieldHas(field: string, value: string): IValuedFieldFilterClause<string> {
    return {
      operator: FilterOps.has,
      field: field,
      value: value
    };
  }

  export function stringFieldInArray(field: string, values: ReadonlyArray<string>): IStringArrayValuedFieldFilterClause {
    return {
      operator: FilterOps.inArray,
      field: field,
      values: values
    };
  }

  export function findFieldFilterClause(
    field: string,
    operator: string,
    filter: ICompositeFilterClause): IFieldFilterClause {
    if (filter && filter.clauses) {
      return <IFieldFilterClause>
        _.find(filter.clauses, clause => {
          const fieldClause = <IFieldFilterClause>clause;
          return fieldClause.field === field && fieldClause.operator === operator;
        });
    }
    return null;
  }

}
